export default "assets/images/marker-e1d0872a.svg";